// types
import { FieldType } from 'types/graphql'

export const AI_SUPPORTED_FIELD_TYPES = [
  FieldType.Text,
  FieldType.Number,
  FieldType.PickList,
  FieldType.Lookup,
  FieldType.RiskMatrix
]
